import { render, staticRenderFns } from "./wdc_campaign_management.vue?vue&type=template&id=683ba4d9"
import script from "./wdc_campaign_management.vue?vue&type=script&lang=js"
export * from "./wdc_campaign_management.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports